import { render, staticRenderFns } from "./BaseCheckBoxGroup.vue?vue&type=template&id=4280589a&scoped=true&"
import script from "./BaseCheckBoxGroup.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBoxGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBoxGroup.vue?vue&type=style&index=0&id=4280589a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4280589a",
  null
  
)

export default component.exports